<svelte:options customElement={{ tag: "bt-progress-bar", shadow: "none", }} />

<script lang="ts">
	import { onMount } from 'svelte';

	export let color: 'blue' | 'yellow' = 'blue';
	export let numerator: number = 4;
	export let denominator: number = 10;

	onMount(() => {
		// Force type number for non-svelte component instances
		numerator = +numerator;
		denominator = +denominator;
	});

</script>
<div class={`progress__bar progress__bar--${color}`} style={
	`--progress-percent: calc(${numerator/denominator} * 100% - ${numerator === 0 ? '2px' : '0px'});`
}></div>

<style>
	.progress__bar {
		position: relative;
		width: 100%;
		height: theme('spacing.2');
		margin-top: theme('spacing.2');
		margin-bottom: theme('spacing.2');
		border-radius: 10px;
		&:before {
			content: '';
			position: absolute;
			top: -1px;
			left: -1px;
			display: block;
			/* The -1px offsets for position and +2px offset for width, in conjunction with
				 the 2px or 0px subtraction from --progress-percent, ensure the progress bar
				 is invisible when 0% and overlaps the right side of the container when 100%
			*/
			width: calc(var(--progress-percent) + 2px);
			height: calc(100% + 2px);
			transition: width 100ms ease-in-out;
			border-radius: 10px;
		}
	}
	.progress__bar--yellow {
		background: white;
		border: 1px solid theme('colors.neutral.300');
		&:before {
			background: theme('colors.yellow');
		}
	}
	.progress__bar--blue {
		background: theme('colors.neutral.200');
		&:before {
			background: theme('colors.sky-blue');
		}
	}
</style>

